import PropTypes from "prop-types"
import { forwardRef, memo } from "react"

import { cn } from "styles/utils"

const Select = forwardRef(
  ({ className, error, errorClassName, ...props }, ref) => (
    <>
      <select
        className={cn(
          "h-46 border-grey-10 focus:border-primary w-full rounded-none border bg-white px-8 align-top text-black outline-none focus:border-2",
          className
        )}
        ref={ref}
        {...props}
      />
      {error && (
        <p className={cn("text-error text-12 mt-8", errorClassName)}>
          {error.message || error}
        </p>
      )}
    </>
  )
)

Select.propTypes = {
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  errorClassName: PropTypes.string,
}

Select.displayName = "Select"

export default memo(Select)
